import { isWeixin } from '@/helpers';
<template>
  <form id="search" class="eating-search" @submit="handleSubmit" action=".">
    <img
      v-if="isWeixin"
      class="eating-search-back"
      src="@/assets/eating/icon-back.png"
      alt="icon-back.png"
      @click="handleBack"
    >
    <label class="eating-search-input">
      <input :value="current" v-bind="$attrs" type="search" @input="handleInput">
      <img src="@/assets/eating/icon-search.png" alt="icon-search.png">
    </label>
    <button class="eating-search-button" form="search">搜索</button>
  </form>
</template>
<script>
import { isWeixin } from '@/helpers';
export default {
  name: 'Search',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    hide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      current: this.value
    }
  },
  computed: {
    isWeixin() {
      return isWeixin()
    }
  },
  watch: {
    value(val) {
      this.current = val
    },
    $route: {
      immediate: true,
      handler() {
        const searchKey = this.$route.query.search
        if (searchKey) {
          this.current = searchKey
        }
      }
    }
  },
  methods: {
    handleInput(e) {
      const value = e.target.value;
      this.$emit('input', value)
    },
    handleSubmit(e) {
      e.preventDefault()
      this.$emit('search', this.current)
    },
    handleBack () {
      this.$router.go(-1)
    }
  }

}
</script>

<style lang="scss">
.eating-search {
  @function pxTOvw($px) {
    @return $px / 2.3
  }
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0;
  &-back {
    height: 10px;
    &.hide {
      opacity: 0;
    }
  }
  &-input {
    position: relative;
    flex: 1;
    margin: 0 15px;
    margin-right: 2px;
    input {
      width: 100%;
      box-sizing: border-box;
      border: 0 none;
      outline: none;
      padding: 5px 30px;
      font-size: 14px;
      line-height: 1.5;
      border-radius: 16px;
      background-color: #f4f3f3;
      -webkit-appearance:none;
    }
    input::-webkit-search-cancel-button {display: none;}
    img {
      position: absolute;
      width: 16px;
      height: 16px;
      top: 8px;
      left: 8px;
    }
  }
  &-button {
    background-color: transparent;
    color: #35B412;
    border: 0 none;
    outline: none;
    font-size: 14px;
  }
}
</style>
